import React, { Component } from 'react';
import { shape, string, number, bool } from 'prop-types';

import styles from './styles.scss';
import classnames from 'classnames';

export default class TableSummary extends Component {
  static propTypes = {
    summaryData: shape({
      title: string,
      ads: number,
      adVisit: number,
      adUser: number,
      visitOfAds: number,
      avgAdCost: number,
      newAdUsers: number,
      newAdUsersOfAds: number,
    }).isRequired,
    isAvgCostDisabled: bool,
    isShowNewAdUsers: bool,
  };

  render() {
    const { summaryData, isAvgCostDisabled, isShowNewAdUsers } = this.props;
    const { title, ads, adVisit, visitOfAds, avgAdCost, newAdUsers, newAdUsersOfAds } = summaryData;
    const formattedTotalAdVisits = Math.round(adVisit);
    // TODO: Replace summary with adUser when implemented and selected from dropdown.

    return (
      <div className={classnames(styles.tableRow, styles.summaryRow)}>
        <div data-test="summaryName" className={styles.tableCell}>{title}</div>
        {isShowNewAdUsers ? (
          <div data-test="summaryNewAdUsers" className={styles.tableCell}>{newAdUsers.toLocaleString()}</div>
        ) : (
          <div data-test="summaryAdVisits" className={styles.tableCell}>{formattedTotalAdVisits.toLocaleString()}</div>
        )}
        {/* <div className={styles.tableCell}>{adUser.toLocaleString()}</div> */}
        <div data-test="summaryAds" className={styles.tableCell}>{ads.toLocaleString()}</div>
        {isShowNewAdUsers ? (
          <div data-test="summaryNewAdUsersOfAds" className={styles.tableCell}>{newAdUsersOfAds.toLocaleString()}</div>
        ) : (
          <div data-test="summaryVisitsAds" className={styles.tableCell}>{visitOfAds.toLocaleString()}</div>
        )}
        {
          !isAvgCostDisabled && <div data-test="summaryAdCost" className={styles.tableCell}>{`$${avgAdCost.toFixed(2).toLocaleString()}`}</div>
        }
      </div>
    );
  }
}
